/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import CartesianCoordinates from '../interactive/CartesianCoordinates';
export const metadata = {
  demo: CartesianCoordinates,
  title: 'Centred Origin Point'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Often when we talk of `}<em parentName="p">{`Cartesian Coordinates`}</em>{`, the `}<strong parentName="p">{`origin point`}</strong>{` `}<inlineCode parentName="p">{`(0, 0)`}</inlineCode>{` is in the centre, and the coordinates can be negative or positive.`}</p>
    <p>{`This will be important as we shift to 3D coordinates. Instead of thinking of "top left" we should begin to think of "relative to the origin point `}<inlineCode parentName="p">{`(0, 0)`}</inlineCode>{`."`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
